import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ContractReadModel, ContractsTotals } from './types';

export const contractsApi = createApi({
  reducerPath: 'contractsApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL + '/contracts' }),
  tagTypes: ['Contracts', 'Contract'],
  endpoints: builder => ({
    getContractsI: builder.infiniteQuery<
      ContractReadModel[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: ['Contracts'],
    }),
    getContractsTotals: builder.query<ContractsTotals, { filter?: string }>({
      query: params => ({ url: '/totals', params }),
      providesTags: ['Contracts'],
    }),
    getContractById: builder.query<ContractReadModel, string>({
      query: id => ({ url: `/${id}` }),
      providesTags: (_, __, id) => [{ type: 'Contract', id }],
    }),
  }),
});

export const { useGetContractByIdQuery, useGetContractsTotalsQuery } =
  contractsApi;

export const useGetContractsIInfiniteQuery = normalizeInfiniteQueryData(
  contractsApi.useGetContractsIInfiniteQuery,
);
